export default {
    ABOUT_TAB: 'ABOUT_TAB',
    ARTICLES_TAB: 'ARTICLES_TAB',
    CANCEL_INVITATION: 'CANCEL_INVITATION',
    CHANGE_ROLE: 'CHANGE_ROLE',
    COLLABORATORS_INVITE: 'COLLABORATORS_INVITE',
    COLLABORATORS_LIST: 'COLLABORATORS_LIST',
    COLLECTIONS_DETAIL: 'COLLECTIONS_DETAIL',
    COLLECTIONS_LIST: 'COLLECTIONS_LIST',
    COLLECTIONS_TAB: 'COLLECTIONS_TAB',
    CREATE_TEAM: 'CREATE_TEAM',
    DELETE: 'DELETE',
    DOSSIERS_DETAIL: 'DOSSIERS_DETAIL',
    DOSSIERS_LIST: 'DOSSIERS_LIST',
    DOSSIERS_TAB: 'DOSSIERS_TAB',
    FAILED_INVITATION_LIST: 'FAILED_INVITATION_LIST',
    MEMBER_CHANGE_ROLE: 'MEMBER_CHANGE_ROLE',
    MEMBER_INVITE: 'MEMBER_INVITE',
    MEMBER_LIST: 'MEMBER_LIST',
    MEMBER_SETTINGS_DROPDOWN: 'MEMBER_SETTINGS_DROPDOWN',
    MEMBER_TAB: 'MEMBER_TAB',
    OUTSIDE_COLLABORATOR_LIST: 'OUTSIDE_COLLABORATOR_LIST',
    OVERVIEW_TAB: 'OVERVIEW_TAB',
    PENDING_COLLABORATOR_LIST: 'PENDING_COLLABORATOR_LIST',
    PENDING_INVITATION_LIST: 'PENDING_INVITATION_LIST',
    REMOVE_COLLABORATORS: 'REMOVE_COLLABORATORS',
    SETTING_BILLING_AND_PLANS: 'SETTING_BILLING_AND_PLANS',
    SETTING_COLLABORATORS: 'SETTING_COLLABORATORS',
    SETTING_IDEA: 'SETTING_IDEA',
    SETTING_LOCATION: 'SETTING_LOCATION',
    SETTING_MEMBER_PRIVILEGES: 'SETTING_MEMBER_PRIVILEGES',
    SETTING_PROFILE: 'SETTING_PROFILE',
    SETTING_PUBLICATIONS: 'SETTING_PUBLICATIONS',
    SETTING_SHORT_URLS: 'SETTING_SHORT_URLS',
    SETTING_SUBSCRIPTION: 'SETTING_SUBSCRIPTION',
    SETTING_TAB: 'SETTING_TAB',
    SETTING_VERIFIED_DOMAIN: 'SETTING_VERIFIED_DOMAIN',
    TEAMS_TAB: 'TEAMS_TAB',
    TEAM_DETAIL: 'TEAM_DETAIL',
    TEAM_INVITE: 'TEAM_INVITE',
    TEAM_INVITE_COUNT: 'TEAM_INVITE_COUNT',
    TEAM_LIST: 'TEAM_LIST',
    TEAM_SETTINGS_DROPDOWN: 'TEAM_SETTINGS_DROPDOWN',
    TEAM_TOTAL_COUNT: 'TEAM_TOTAL_COUNT',
    UPDATE_INVITATION: 'UPDATE_INVITATION'
}